import { createFileRoute } from "@tanstack/react-router";

import { ForgeMobilePairingPage } from "../components/mobile/ForgeMobilePairingPage";

export const Route = createFileRoute("/mobile")({
  component: ForgeMobilePairingPage,
});
